import moment from 'moment-timezone';

const parseUtcMoment = (value) => {
  if (!value) return null;
  const parsed = moment.utc(
    value,
    [
      moment.ISO_8601,
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DDTHH:mm:ss',
      'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
      'YYYY-MM-DDTHH:mm:ss[Z]',
    ],
    true
  );
  return parsed.isValid() ? parsed : null;
};

export const scheduleAssessmentTimers = (assessments, callbacks) => {
  const timeouts = [];

  (assessments || []).forEach((assessment) => {
    if (!assessment || Number(assessment.is_time_based) !== 1) return;

    const assessmentId = assessment.assessment_id ?? assessment.id;
    const activateAt = parseUtcMoment(assessment.activate_time);
    const deactivateAt = parseUtcMoment(assessment.deactivate_time);
    const now = moment.utc();

    if (activateAt && activateAt.isAfter(now) && Number(assessment.is_active) !== 1) {
      const delay = Math.max(0, activateAt.diff(now));
      timeouts.push(
        setTimeout(() => {
          callbacks?.onActivate?.({
            assessmentId,
            is_active: 1,
            activate_time: assessment.activate_time,
            deactivate_time: assessment.deactivate_time,
          });
        }, delay)
      );
    }

    if (deactivateAt && deactivateAt.isAfter(now) && Number(assessment.is_active) === 1) {
      const delay = Math.max(0, deactivateAt.diff(now));
      timeouts.push(
        setTimeout(() => {
          callbacks?.onDeactivate?.({
            assessmentId,
            is_active: 0,
            activate_time: assessment.activate_time,
            deactivate_time: assessment.deactivate_time,
          });
        }, delay)
      );
    }
  });

  return () => {
    timeouts.forEach((timeoutId) => clearTimeout(timeoutId));
  };
};

export const scheduleAssignmentDueTimers = (assignments, callbacks) => {
  const timeouts = [];

  (assignments || []).forEach((assignment) => {
    if (!assignment?.due_date) return;

    const assignmentId = assignment.id ?? assignment.assignment_id;
    const dueAt = parseUtcMoment(assignment.due_date);
    const now = moment.utc();

    if (!dueAt || !dueAt.isAfter(now)) return;

    const delay = Math.max(0, dueAt.diff(now));
    timeouts.push(
      setTimeout(() => {
        callbacks?.onDueReached?.({
          assignmentId,
          due_date: assignment.due_date,
        });
      }, delay)
    );
  });

  return () => {
    timeouts.forEach((timeoutId) => clearTimeout(timeoutId));
  };
};

export const scheduleAssignmentDueTimer = (assignmentId, dueDate, onDueReached) =>
  scheduleAssignmentDueTimers([{ id: assignmentId, due_date: dueDate }], { onDueReached });
